/**
 * User Settings Utility
 *
 * Stores per-device user preferences in localStorage.
 * These settings are device/browser-specific and are NOT synced
 * across devices or tied to the user account.
 *
 * Usage:
 *   import { getUserSetting, setUserSetting } from '@/utils/userSettings';
 *   const useOld = getUserSetting('useOldDashboard', false);
 *   setUserSetting('useOldDashboard', true);
 */

const STORAGE_KEY = 'tpa.userSettings';

function readAll() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Could not read userSettings from localStorage', e);
    return {};
  }
}

function writeAll(obj) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(obj));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Could not write userSettings to localStorage', e);
  }
}

export function getUserSetting(key, defaultValue = null) {
  const all = readAll();
  return Object.prototype.hasOwnProperty.call(all, key) ? all[key] : defaultValue;
}

export function setUserSetting(key, value) {
  const all = readAll();
  all[key] = value;
  writeAll(all);
}

export function getAllUserSettings() {
  return readAll();
}

export function resetUserSettings() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Could not reset userSettings', e);
  }
}

export default {
  get: getUserSetting,
  set: setUserSetting,
  all: getAllUserSettings,
  reset: resetUserSettings
};
